import React, { CSSProperties, Ref, useRef, useState } from "react";
import { useEffect } from "react";
import { Link, useHistory } from "react-router-dom";
import ColorButton from "antd-button-color";
import { useTranslation } from 'react-i18next';
import { t } from "i18next";
import {
  Row,
  Col,
  Carousel,
  Card,
  Typography,
  Tag,
  Button,
  Avatar,
  message,
} from "antd";
import { fetchHomeTrack, TrackModel } from "../../api/track";
import { getCompetitions, CompetitionModel } from "../../api/competitions"
import NavHeader, { headerRef } from "../components/header";
import NavFooter from "../components/footer";
import { Scrollbars } from "react-custom-scrollbars";
import { CloudDownloadOutlined, FileOutlined, LeftOutlined, RightOutlined } from "@ant-design/icons";
import {
  DatasetModel,
  fetchDatasets,
} from "../../api/problem";
import cssStyle from "./index.module.css";
import { CarouselRef } from "antd/lib/carousel";
import rankImg from "../../assets/whtrank.png";
import openiImg from "../../assets/openiImg.png";
import JPic from "../../assets/join.png"

import rPng from "../../assets/R.png";
import lPng from "../../assets/L.png"
import HlsPlayer from "./liveBroadcast"
import videoSrc from '../../assets/第五届全国人工智能大赛.m4v';

const { Title, Text } = Typography;
export interface IPComp {
  trackId: number;
  contestId: number;
}
export const Competitions: React.FunctionComponent<CompetitionModel> = (props) => {
  const { 
    bonus, co_organizer, competition_status, description, end_time, identifier, id, image, is_new,member_count,name,nearly_published,organizer,published_at,sponsor,start_time,team_count 
  } = props;
  const award = "¥" + bonus
  const imgUrl = "https://app-kyxt.pcl.ac.cn" + image
  const abstract = description.length>90?description.slice(0,90)+"……":description || "简介";

  const history = useHistory();

  
  return (
    <Card
      key={`${id}-card`}
      style={{
        width: "100%",
        margin: "32px 0",
        height: "286px",
      }}
    >
      <ColorButton
        style={{
          width: "130px",
          margin: "0",
          height: "30px",
          transform: "rotateZ(45deg)",
          clipPath: "polygon(30px 0px,100px 0px, 130px 30px,0px 30px)",
          position: "absolute",
          right: -30,
          top: 20

        }}
        type={
          competition_status === "progressing"
            ? "info"
            : competition_status === "compete"
              ? "success"
              : "warning"
        }
        onClick={() => {
          window.open(`https://app-kyxt.pcl.ac.cn/competitions/detail/${identifier}`, '_blank');
          // history.push(`/competitions/detail/${identifier}`)
        }}
      >
        {competition_status === "progressing"
          ? t("进行中")
          : competition_status === "compete"
            ? t("即将开始")
            : t("已结束")}
      </ColorButton>
      <Row
        style={{
          width: "100%",
          height: "236px",
        }}
        justify="space-around"
      >
        <Col
          span={4}
          style={{
            backgroundImage: `url(${imgUrl})`,
            backgroundRepeat: "no-repeat",
            backgroundSize: "contain",
            backgroundPosition: "center",
          }}
        ></Col>
        <Col offset={0} span={19}>
          <Row justify="space-between">
            <Col style={{ width: 450 }}>
              <Title level={3} style={{ fontSize: 20, height: 28, margin: 0 }}>
                <a href={`https://app-kyxt.pcl.ac.cn/competitions/detail/${identifier}`} target="_blank">{name}</a>
                {/* <Link to={`/competitions/detail/${identifier}`}>{name}</Link> */}
              </Title>
              <Scrollbars style={{ width: "100%", height: 65, marginTop: 10, marginBottom: 12 }}>
                <Text type="secondary">{abstract}</Text>
              </Scrollbars>
            </Col>
            <Col style={{ width: 450 }} >
              <Title level={3} style={{ fontSize: 20, height: 28, margin: 10 }}>
                {" "}
              </Title>
              <Row style={{ width: "100%" }}>
                <Col span={7}>
                  <Button type="text" block>
                    <Text type="secondary">{t("奖励")}</Text>
                  </Button>
                  <p
                    style={{
                      lineHeight: "32px",
                      textAlign: "center",
                      fontSize: 24,
                      fontWeight: 400,
                      fontFamily: "Roboto"
                    }}
                  >
                    {award}
                  </p>
                </Col>
                <Col span={7}>
                  <Button type="text" block>
                    <Text type="secondary">{t("参赛队伍")}</Text>
                  </Button>
                  <p
                    style={{
                      lineHeight: "32px",
                      textAlign: "center",
                      fontSize: 24,
                      fontWeight: 400,
                      fontFamily: "Roboto"
                    }}
                  >
                    {team_count}
                  </p>
                </Col>

                <Col span={7}>
                  <Button type="text" block>
                    <Text type="secondary">{t("参赛人数")}</Text>
                  </Button>
                  <p
                    style={{
                      lineHeight: "32px",
                      textAlign: "center",
                      fontSize: 24,
                      fontWeight: 400,
                      fontFamily: "Roboto"
                    }}
                  >
                    {member_count}
                  </p>
                </Col>

              </Row>
            </Col>
            <Col>
              <Text type="secondary" style={{ fontSize: 13, height: 18, margin: 0 }}>
                <div style={{display: "flex", flexWrap: 'nowrap', alignItems: "center",whiteSpace: 'nowrap'}}>
                  <div style={{width: "70px", color: "rgb(144, 150, 163)",fontSize: '14px'}}>主办单位</div>
                  <div style={{color: "#333"}}>{sponsor}</div>
                </div>
              </Text>
              <Text style={{ fontSize: 13, height: 18, margin: 0 }}>
                <div style={{display: "flex", flexWrap: 'nowrap', alignItems: "center",whiteSpace: 'nowrap'}}>
                  <div style={{width: "70px", color: "rgb(144, 150, 163)",fontSize: '14px'}}>承办单位</div>
                  <div style={{color: "#333"}}>{organizer}</div>
                </div>
              </Text>
              <Text type="secondary" style={{ fontSize: 13, height: 18, margin: 0, whiteSpace:"pre-wrap" }}>
                <div style={{display: "flex", flexWrap: 'nowrap', alignItems: "center",whiteSpace: 'nowrap'}}>
                  <div style={{width: "70px", color: "rgb(144, 150, 163)",fontSize: '14px'}}>协办单位</div>
                  <div style={{color: "#333"}}>{co_organizer}</div>
                </div>
              </Text>
            </Col>
          </Row>
        </Col>

      </Row>
    </Card>
  )
}
export const Competition: React.FunctionComponent<TrackModel> = (props) => {
  const { title, tags, intro, prize, imgSrc, users, configTrackStatus, id, competition, times,stageStartTime,stageEndTime } = props;
  const name = title || "名字";
  const Award = +prize > 0 ? ("￥"+prize):((JSON.parse(tags)as string[])?.map((tag) => (
    tag.split(":")[0]=="比赛奖励"?
    (
      tag.split(":")[1]
    )
    :(null)
  )) || []);
  let arrTag: string[] = [];
  //const [showteam, setShowteam] = useState(users);
  let showteam = users;
  try {
    arrTag = (JSON.parse(tags) as string[]);
    arrTag.map((s)=>
      {
        if(s.split(":")[0] == "参赛人数")
        {
          showteam = Number(s.split(":")[1]);
        }
      }
    )
  } catch {
    arrTag = [];
  }
  const realTags = arrTag || [];
  const abstract = intro.length>90?intro.slice(0,90)+"……":intro || "简介";
  const imageUrl = imgSrc || "/logo.svg";
  const status = Date.now()<stageStartTime?"compete":Date.now()<=stageEndTime?"apply":"ended";/*configTrackStatus === 1
    ? "apply"
    : configTrackStatus === 2
      ? "compete"
      : "ended";*/
  const trackId = id || -1;

  const contestId = competition || -1;
  type Color =
    | "magenta"
    | "red"
    | "volcano"
    | "orange"
    | "gold"
    | "lime"
    | "green"
    | "cyan"
    | "blue"
    | "geekblue"
    | "purple";

  const colors: Color[] = [
    "magenta",
    "red",
    "volcano",
    "orange",
    "gold",
    "lime",
    "green",
    "cyan",
    "blue",
    "geekblue",
    "purple",
  ];

  const getHashColor = (str: string): Color => {
    let buf = Buffer.from(str);
    let res = buf.reduce((total, current) => {
      return total + current;
    });
    return colors[res % colors.length];
  };

  const history = useHistory();
  return (
    <Card
      key={`${id}-${competition}-card`}
      style={{
        width: "100%",
        margin: "32px 0",
        height: "286px",
      }}
    >
      <ColorButton
        style={{
          width: "130px",
          margin: "0",
          height: "30px",
          transform: "rotateZ(45deg)",
          clipPath: "polygon(30px 0px,100px 0px, 130px 30px,0px 30px)",
          position: "absolute",
          right: -30,
          top: 20

        }}
        type={
          status === "apply"
            ? "info"
            : status === "compete"
              ? "success"
              : "warning"
        }
        onClick={() => {
          history.push(`/contest/${contestId}/${trackId}`)
        }}
      >
        {status === "apply"
          ? t("进行中")
          : status === "compete"
            ? t("即将开始")
            : t("已结束")}
      </ColorButton>
      <Row
        style={{
          width: "100%",
          height: "236px",
        }}
        justify="space-around"
      >
        <Col
          span={4}
          style={{
            backgroundImage: `url(${imageUrl})`,
            backgroundRepeat: "no-repeat",
            backgroundSize: "contain",
            backgroundPosition: "center",
          }}
        ></Col>
        <Col offset={0} span={19}>
          <Row justify="space-between">
            <Col style={{ width: 450 }}>
              <Title level={3} style={{ fontSize: 20, height: 28, margin: 0 }}>
                <Link to={`/contest/${contestId}/${trackId}`}>{name}</Link>
              </Title>
              <Text style={{ fontSize: 20, height: 22, margin: 0 }}>
                {realTags.map((tag) => (
                  (tag.split(":")[0]=="tag")?
                  (
                  <Tag style={{
                    marginRight: "5px",
                    height: 22,
                    lineHeight: "16px"
                  }} color={getHashColor(tag)} key={`tag-${trackId}-${contestId}-${tag}`}>
                    {tag.split(":")[1]}
                  </Tag>
                  )
                  :(null)
                ))}
              </Text>
              <Scrollbars style={{ width: "100%", height: 65, marginTop: 10, marginBottom: 12 }}>
                <Text type="secondary">{abstract}</Text>
              </Scrollbars>
            </Col>

            <Col style={{ width: 450 }} >
              <Title level={3} style={{ fontSize: 20, height: 28, margin: 10 }}>
                {" "}
              </Title>
              <Row style={{ width: "100%" }}>
                <Col span={7}>
                  <Button type="text" block>
                    <Text type="secondary">{t("奖励")}</Text>
                  </Button>
                  <p
                    style={{
                      lineHeight: "32px",
                      textAlign: "center",
                      fontSize: 24,
                      fontWeight: 400,
                      fontFamily: "Roboto"
                    }}
                  >
                    {Award}
                  </p>
                </Col>
                <Col span={7}>
                  <Button type="text" block>
                    <Text type="secondary">{t("参赛人数")}</Text>
                  </Button>
                  <p
                    style={{
                      lineHeight: "32px",
                      textAlign: "center",
                      fontSize: 24,
                      fontWeight: 400,
                      fontFamily: "Roboto"
                    }}
                  >
                    {showteam}
                    {/* {trackId} */}
                  </p>
                </Col>

                <Col span={10}>
                  <Button type="text" block>
                    <Text type="secondary">{t("比赛时间")}</Text>
                  </Button>
                  <p
                    style={{
                      lineHeight: "32px",
                      textAlign: "center",
                      fontSize: 24,
                      fontWeight: 400,
                      fontFamily: "Roboto"
                    }}
                  >
                    {times}
                  </p>
                </Col>

              </Row>
            </Col>
            <Col>
              <Text type="secondary" style={{ fontSize: 13, height: 18, margin: 0 }}>
                {realTags.map((tag) => (
                    (tag.split(":")[0]=="主办单位")?
                    (
                      t(tag.split(":")[0]) + "："
                    )
                    :(null)
                ))}
              </Text>
              <Text style={{ fontSize: 13, height: 18, margin: 0 }}>
                {realTags.map((tag) => (
                    (tag.split(":")[0]=="主办单位")?
                    (
                      tag.split(":")[1]
                    )
                    :(null)
                ))}
              </Text>
              <Text type="secondary" style={{ fontSize: 13, height: 18, margin: 0, whiteSpace:"pre-wrap" }}>
                {realTags.map((tag) => (
                    (tag.split(":")[0]=="承办单位")?
                    (
                      "\n"+
                      t(tag.split(":")[0]) + "："
                    )
                    :(null)
                ))}
              </Text>
              <Text style={{ fontSize: 13, height: 18, margin: 0 }}>
                {realTags.map((tag) => (
                    (tag.split(":")[0]=="承办单位")?
                    (
                      tag.split(":")[1]
                    )
                    :(null)
                ))}
              </Text>
              <Text type="secondary" style={{ fontSize: 13, height: 18, margin: 0, whiteSpace:"pre-wrap" }}>
                {realTags.map((tag) => (
                    (tag.split(":")[0]=="协办单位")?
                    (
                      "\n"+
                      t(tag.split(":")[0]) + "："
                    )
                    :(null)
                ))}
              </Text>
              <Text style={{ fontSize: 13, height: 18, margin: 0 }}>
                {realTags.map((tag) => (
                    (tag.split(":")[0]=="协办单位")?
                    (
                      tag.split(":")[1]
                    )
                    :(null)
                ))}
              </Text>
              <Text type="secondary" style={{ fontSize: 13, height: 18, margin: 0, whiteSpace:"pre-wrap" }}>
                {realTags.map((tag) => (
                    (tag.split(":")[0]=="赛题冠名单位")?
                    (
                      "\n"+
                      t(tag.split(":")[0]) + "："
                    )
                    :(null)
                ))}
              </Text>
              <Text style={{ fontSize: 13, height: 18, margin: 0 }}>
                {realTags.map((tag) => (
                    (tag.split(":")[0]=="赛题冠名单位")?
                    (
                      tag.split(":")[1]
                    )
                    :(null)
                ))}
              </Text>
              <Text type="secondary" style={{ fontSize: 13, height: 18, margin: 0, whiteSpace:"pre-wrap" }}>
                {realTags.map((tag) => (
                    (tag.split(":")[0]=="数据支持单位")?
                    (
                      "\n"+
                      t(tag.split(":")[0]) + "："
                    )
                    :(null)
                ))}
              </Text>
              <Text style={{ fontSize: 13, height: 18, margin: 0 }}>
                {realTags.map((tag) => (
                    (tag.split(":")[0]=="数据支持单位")?
                    (
                      tag.split(":")[1]
                    )
                    :(null)
                ))}
              </Text>
            </Col>
          </Row>
        </Col>
      </Row>
    </Card >
  );
};

export interface IDataset {
  name: string;
  desc: string;
  size: string;
  fileKey: string;
  downloadTime: number;
  id: number;
}
export const Dataset: React.FunctionComponent<IDataset> = (props) => {
  const { name, desc, size, downloadTime, id } = props;
  let [imageUrl] = useState<string>("/2020logo.jpg");
  const download = () => {
    message.info(t('报名参赛后方可下载'))
    // getDatasetFileUrl(id, fileKey)
    //   .then((data) => {
    //     window.open(data);
    //   })
    //   .catch((err) => console.log(err));
    // 2021/9/14
  }

  if (id === 2) {
    imageUrl = "/2019logo.jpg";
  }

  return (
    <Card
      style={{
        width: "100%",
        margin: "30px 0",
      }}

    >
      <Row
        style={{
          width: "100%",
          height: "170px",
        }}
      >
        <Col
          span={5}
          style={{
            width: "240px",
            height: "160px",
            backgroundImage: `url(${imageUrl})`,
            backgroundRepeat: "no-repeat",
            backgroundSize: "contain",
            backgroundPosition: "center",
          }}
        ></Col>
        <Col offset={1} span={18}>
          <Title level={3}>{name}</Title>
          <Scrollbars style={{ width: "100%", height: 90 }}>
            <Text type="secondary">{desc}</Text>
            {/* <Text type="secondary">{id}</Text> */}
          </Scrollbars>
          <br />
          <Row>
            <Col span={8}>
              {/* 这里改成了敬请期待 + 灰色 2021/9/14 */}
              <CloudDownloadOutlined style={{ margin: "0 5px" }} />
              &nbsp;
              <a onClick={download} style={{ color: "gray" }}>{t("下载数据")}</a>
            </Col>
            <Col span={8}>
              <FileOutlined style={{ margin: "0 5px" }} />
              {t("已下载")}&nbsp;{downloadTime}&nbsp;{t("次")}
            </Col>
            <Col span={8}>
              <FileOutlined style={{ margin: "0 5px" }} />
              {t("文件大小")}：&nbsp;{size}
            </Col>
          </Row>
        </Col>
      </Row>
    </Card>
  );
};

export const List: React.FunctionComponent = () => {
  const { t, i18n } = useTranslation();
  const contentStyle: CSSProperties = {
    height: "480px",
    color: "#fff",
    lineHeight: "480px",
    textAlign: "center",
    background: "#364d79"
  };
  const imageStyle: CSSProperties = {
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover",
  };
  const [dataset, setDataset] = useState<DatasetModel[]>([]);
  const [tracks, setTracks] = useState<TrackModel[]>([]);
  const [competitions, setCompetitions] = useState<CompetitionModel[]>([]);
  useEffect(() => {
    fetchHomeTrack()
      .then((data) => {
        setTracks(data);
      })
      .catch((err) => console.log(err));
    fetchDatasets()
      .then((data) => {
        setDataset(data);
      })
      .catch((err) => console.log(err));
    getCompetitions()
      .then((data) => {
        setCompetitions(data);
      })
      .catch((err) => console.log(err));

  }, []);
  const header = useRef<headerRef>(null);
  const slider = useRef<CarouselRef>();
  const texts = [
    "第五届全国人工智能大赛","第四届全国人工智能大赛","2021全国人工智能大赛", "2020全国人工智能大赛", "首届全国人工智能大赛","启智AI开发协作平台","昇腾社区APP"
  ]
  const subtexts = [
    "AI赋能视界",
    "AI赋能视界",
    "AI赋能视界",
    "AI赋能视界",
    "AI赋能视界",
    "免费算力支持",
  ]
  const clicks = [
    () => {
      window.location.href = "https://app-kyxt.pcl.ac.cn/competitions/group/v3atucf9";
    },() => {
      window.location.href = "https://naic.pcl.ac.cn/landingpage/2023/index.html";
    },() => {
      window.location.href = "https://naic.pcl.ac.cn/landingpage/2021/index.html";
    }, () => {
      // window.location.href = "http://www.china-ai.ac.cn/";
      window.location.href = "https://naic.pcl.ac.cn/landingpage/2020/index.html";
    }, () => {
      // history.push("/landingpage/2021");
      window.location.href = "https://naic.pcl.ac.cn/landingpage/2019/index.html";
    }, () => {
      window.location.href = "https://openi.pcl.ac.cn/";
    }
  ]
  const banner_icons = [rankImg,rankImg,rankImg,rankImg,openiImg,rankImg,rankImg]
  const history = useHistory();
  const [show_all_competitions, set_show_all_competitions] = useState<boolean>(false);
  return (
    <>
      <NavHeader theme="light" ref={header} />
      <Row justify="center" style={{margin:"auto",minWidth:"1200px"}}>
        <Col style={{ flex: "auto", width: "80%", maxWidth: "1200px", minWidth:"1200px",justifyContent:"center",margin:"auto" }}>
          <Carousel
            
            infinite
            ref={slider as Ref<CarouselRef>}
            arrows={true}
            className={cssStyle.arrowIcon}
            prevArrow={<LeftOutlined />}
            nextArrow={<RightOutlined />}
            speed={500}
            appendDots={dots => (
              <div
                style={{
                  backgroundColor: "rgba(90,90,90,.3)",
                  width: "100%",
                  margin: 0,
                  height: 100,
                  cursor: "default",
                  overflow: "hidden"
                }}
              >
                <ul style={{
                  margin: "0 auto", padding: 0, height: "100%",
                  width: "100%",
                  whiteSpace:"nowrap",
                  display:"flex",
                  justifyContent:"center"
                }}> {dots} </ul>
              </div>
            )}
            customPaging={i => (
              <Row
                className={cssStyle.slider}
                onMouseOver={() => {
                  slider.current?.goTo(i)
                }}
                onMouseEnter={() => {
                  slider.current?.goTo(i)
                }}
                justify="center"
                align="middle"
              ><Col onClick={clicks[i]} style={{
                cursor: "pointer"
              }}>
                  <img src={banner_icons[i]} alt={`logo-${i}`} style={{
                    height: 45,
                    width: 45,
                    textAlign: "center",
                    whiteSpace: "pre",
                  }}
                  />
                </Col>
                <Col
                  className={cssStyle.sliderText} onClick={clicks[i]}
                >
                  <span style={{ fontSize: "4px" }}>
                    {texts[i]}
                  </span>
                  <br />

                  <span style={{ fontSize: "4px " }}>
                    {subtexts[i]}
                  </span></Col>

              </Row>
            )}
          >
            <div>
              <div
                onClick={clicks[0]}
                style={{
                  ...contentStyle,
                  ...imageStyle,
                  backgroundImage: `url(${"https://naic.pcl.ac.cn/2024banner.jfif"})`,
                }}
              ></div>
            </div>
            <div>
              <div
                onClick={clicks[1]}
                style={{
                  ...contentStyle,
                  ...imageStyle,
                  backgroundImage: `url(${"https://naic.pcl.ac.cn/2023banner.jpg"})`,
                }}
              ></div>
            </div>
            <div>
              <div
                onClick={clicks[2]}
                style={{
                  ...contentStyle,
                  ...imageStyle,
                  backgroundImage: `url(${"https://naic.pcl.ac.cn/2021banner.png"})`,
                }}
              ></div>
            </div>
            <div>
              <div
                onClick={clicks[3]}
                style={{
                  ...contentStyle,
                  ...imageStyle,
                  backgroundImage: `url(${"https://naic.pcl.ac.cn/2020banner.jpg"})`,
                }}
              ></div>
            </div>
            <div> <div
              onClick={clicks[4]}
              style={{
                ...contentStyle,
                ...imageStyle,
                backgroundImage: `url(${"https://naic.pcl.ac.cn/2019banner.png"})`,
              }}
            ></div>
            </div>
            <div> <div
              onClick={clicks[5]}
              style={{
                ...contentStyle,
                ...imageStyle,
                backgroundImage: `url(${"https://naic.pcl.ac.cn/openIbanner.jpg"})`,
              }}
            ></div>
            </div>
            <div>
              <div
                onClick={clicks[6]}
                style={{
                  ...contentStyle,
                  ...imageStyle,
                  backgroundImage: `url(${"https://naic.pcl.ac.cn/shengteng_app.jpg"})`,
                }}
              ></div>
            </div>
          </Carousel>
          <Title
            level={1}
            style={{
              margin: "72px auto 52px auto",
              textAlign: "center",
              fontSize: 32,
              fontWeight: 500,
              color: 'rgba(34, 89, 150, 1)',
            }}
          >
            <img src={rPng} />
             {t("宣传视频")} 
            <img src={lPng} />
          </Title>
          {/* <HlsPlayer /> */}
          {/* ----上面HlsPlayer是直播的组件，下面注释是播放宣传视频的逻辑---- */}
          <video controls width="100%">
            <source src={videoSrc} type="video/mp4"/>
          </video>
          {/* <div>直播开始时间：2025.04.30 13:30</div> */}
          <Title
            level={1}
            style={{
              margin: "72px auto 52px auto",
              textAlign: "center",
              fontSize: 32,
              fontWeight: 500,
              color: 'rgba(34, 89, 150, 1)',
            }}
          >
            <img src={rPng} />
             {t("赛道")} 
            <img src={lPng} />
          </Title>
          {/* {(show_all_competitions||tracks.length<=3?tracks:tracks.slice(0,3)).map((track) => (
              <Competition {...track} key={`track-${track.id}`} />
            ))
            } */}
          {(show_all_competitions||competitions.length<=4?competitions:competitions.slice(0,4)).map((competition) => (
              <Competitions {...competition} key={`competition-${competition.id}`} />
            ))
          }
          {/* <Row style={{
            width: "120px",
            margin: "auto"
          }} >
          <Button  onClick={() => {
            set_show_all_competitions(!show_all_competitions);
          }}
          style={{
            width: "120px"
          }} 
          className={cssStyle.layer12}>
            <span className={cssStyle.word18}>{t(show_all_competitions?"收起":"更多赛道")}</span>
          </Button>
          </Row> */}
          <Title
            level={1}
            style={{
              margin: "72px auto 52px auto",
              textAlign: "center",
              fontSize: 32,
              fontWeight: 500,
              color: 'rgba(34, 89, 150, 1)',
            }}
          >
            <img src={rPng} />
             {t("数据集")}
            <img src={lPng} />
          </Title>
          {dataset.slice(-3).map((dataset) => (
            <Dataset {...dataset} key={`data-${dataset.id}`} />
          ))}
          <Row style={{
            width: "120px",
            margin: "auto"
          }} >
          <Button  onClick={() => {
            history.push(`/dataset`);
          }}
          style={{
            width: "120px"
          }} 
          className={cssStyle.layer12}>
            <span className={cssStyle.word18}>{t("更多数据")}</span>
          </Button>
          </Row>
          <Title
            level={1}
            style={{
              margin: "72px auto 52px auto",
              textAlign: "center",
              fontSize: 32,
              fontWeight: 500,
              color: 'rgba(34, 89, 150, 1)',
            }}
          >
            <img src={rPng} />
             {t("常设技术委员会")} 
            <img src={lPng} />
          </Title>
          {/* <>
            <Row justify="center">
              <Card
                className={cssStyle.chairmanCardL}
                cover={
                  <Avatar
                    src="https://gitee.com/bqsgwys/image/raw/master/yuquan.jpg"
                    size={140}
                    style={{ margin: "20px auto 0 auto" }}
                  ></Avatar>
                }
                bodyStyle={{ padding: "5px" }}
              >
                <div style={{ textAlign: "center", fontSize: "1.3em" }}>
                  于全
                  <br />
                  主席
                  <br />
                  中国工程院院士
                </div>
              </Card>
              <Card
                className={cssStyle.chairmanCardL}
                cover={
                  <Avatar
                    src="https://gitee.com/bqsgwys/image/raw/master/zhangping.jpg"
                    size={140}
                    style={{ margin: "20px auto 0 auto" }}
                  ></Avatar>
                }
                bodyStyle={{ padding: "5px" }}
              >
                <div style={{ textAlign: "center", fontSize: "1.3em" }}>
                  张平
                  <br />
                  主席
                  <br />
                  中国工程院院士
                </div>
              </Card>
            </Row>
          </> */}
          <Row justify="space-around">
            <Card
              className={cssStyle.chairmanCard}
              cover={
                <Avatar
                  src="./lige.jpg"
                  size={100}
                  style={{ margin: "20px auto 0 auto" }}
                ></Avatar>
              }
              bodyStyle={{ padding: "5px" }}
            >
              <div style={{ textAlign: "center" }}>
                李革
                <br />
                专家委员
                <br />
                
              </div>
            </Card>
            <Card
              className={cssStyle.chairmanCard}
              cover={
                <Avatar
                  src="./dingwenhua.jpg"
                  size={100}
                  style={{ margin: "20px auto 0 auto" }}
                ></Avatar>
              }
              bodyStyle={{ padding: "5px" }}
            >
              <div style={{ textAlign: "center" }}>
                丁文华
                <br />
                专家委员
                <br />
                中国工程院院士
              </div>
            </Card>
            <Card
              className={cssStyle.chairmanCard}
              cover={
                <Avatar
                  src="./gaowen.jpg"
                  size={100}
                  style={{ margin: "20px auto 0 auto" }}
                ></Avatar>
              }
              bodyStyle={{ padding: "5px" }}
            >
              <div style={{ textAlign: "center" }}>
                高文
                <br />
                委员会主席
                <br />
                中国工程院院士
                <br />
                鹏城实验室主任
              </div>
            </Card>
            <Card
              className={cssStyle.chairmanCard}
              cover={
                <Avatar
                  src="./yuquan.jpg"
                  size={100}
                  style={{ margin: "20px auto 0 auto" }}
                ></Avatar>
              }
              bodyStyle={{ padding: "5px" }}
            >
              <div style={{ textAlign: "center" }}>
                于全
                <br />
                专家委员
                <br />
                中国工程院院士
              </div>
            </Card>
            <Card
              className={cssStyle.chairmanCard}
              cover={
                <Avatar
                  src="./yangjiankun.jpg"
                  size={100}
                  style={{ margin: "20px auto 0 auto" }}
                ></Avatar>
              }
              bodyStyle={{ padding: "5px" }}
            >
              <div style={{ textAlign: "center" }}>
                杨建坤
                <br />
                专家委员
                <br />
                
              </div>
            </Card>


          </Row>
        </Col>
      </Row>
      <Col className={cssStyle.section20}
        style={
          {
            backgroundImage: `url(${JPic})`,
            backgroundSize: "cover",
            backgroundRepeat: "no-repeat",
            minWidth:"1200px"
          }
        }>
        <div className={cssStyle.word17}>{t("快来加入吧！")}</div>
        <div className={cssStyle.info18}>赛道任你选，大奖等你拿</div>
        <Button /*onClick={() => {
          header?.current?.registry();
        }}*/ shape="round" className={cssStyle.layer11}>
          <span className={cssStyle.word18}>{t("立即加入")}</span>
        </Button>
      </Col>
      <NavFooter
        short
        theme="dark"
      />
    </>
  );
};

export default List;
